export default __webpack_public_path__ + "static/media/granville03.9d579876.jpg";